export default __webpack_public_path__ + "static/media/check2.f5eaa843.svg";